export default function DisclaimerCaption() {
  return (
    <p className="px-1 text-center text-xs leading-relaxed text-gray-500">
      AI can make mistakes; always check important info. Chat data is shared with the
      Company.
    </p>
  )
}
